// extracted by mini-css-extract-plugin
export var errorIcon = "_oo-1";
export var nameLogo = "_oo-0";